
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorGeneral75 as ObiTwowayAcuatorGeneral75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-general-75.js';
 
 
 

 
 export const ObiTwowayAcuatorGeneral75 = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-general-75',
   elementClass: ObiTwowayAcuatorGeneral75Element,
   events: {
     
   }
  });
 
 